export default __webpack_public_path__ + "static/media/Vector 71 (1).31f171cf.svg";